import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import DeviationDumbView from '../../Dumbo/';
import DeviationLink from '../../../Duperbrowse/DeviationLink';
import UserAvatar from '../../../User/Avatar';
import UserLink from '../../../User/Link';
import { getDeviationType } from '../../_helpers';
import DailyDevInfo from './DailyDevInfo';
import ErrorBoundary from '../../../ErrorBoundary';
import OverlayContext from '../Standard/Overlay/OverlayContext';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import s from './DailyDev.scss';
export var MobileDailyDev = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, title = _b.title, textContent = _b.textContent, author = _b.author, dailyDeviation = _b.dailyDeviation, width = _a.width, height = _a.height, showMatureContent = _a.showMatureContent;
    var isLiterature = getDeviationType(deviation) === 'literature';
    var thumbHeight = (height || 0) - 117;
    var hideContent = (!showMatureContent && deviation.isMature) || deviation.isBlocked;
    return (React.createElement(OverlayContext.Consumer, null, function (_a) {
        var _b = _a.showAuthor, showAuthor = _b === void 0 ? true : _b, _c = _a.showTitle, showTitle = _c === void 0 ? true : _c;
        return (React.createElement("div", { className: classnames(s['root']), style: { width: width, height: height } },
            React.createElement(ErrorBoundary, null,
                React.createElement("div", { className: s['mobile-top'] },
                    React.createElement("div", { className: s['badge'] }),
                    React.createElement(DeviationLink, { deviation: deviation, className: s['link'], title: title },
                        React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: thumbHeight, coverLetterClassName: s['literature-cover-letter'], allowPreviewUsage: true, useTextlessMode: true })),
                    React.createElement("div", { className: s['fade'] })),
                React.createElement("div", { className: s['mobile-foot'] },
                    React.createElement("div", { className: s['info'] },
                        React.createElement(DeviationLink, { deviation: deviation, className: s['link'], title: title },
                            showTitle && React.createElement("div", { className: s['title'] }, title),
                            isLiterature && !hideContent && (React.createElement(ExcerptRenderer, { className: s['text-content'], textContent: textContent }))),
                        showAuthor && author && (React.createElement("div", { className: s['attribution'] },
                            React.createElement("div", null,
                                React.createElement(UserAvatar, { className: s['avatar'], user: author, size: 24 })),
                            React.createElement("div", { className: s['author'] },
                                React.createElement("div", null,
                                    React.createElement(Trans, { i18nKey: "deviationview.dailydev.author" },
                                        React.createElement("span", { className: s['dd-by'] }, "By "),
                                        React.createElement(UserLink, { className: s['user-link'], user: author, biData: {
                                                creatorid: author.useridUuid,
                                            } }))))))),
                    dailyDeviation && (React.createElement(DailyDevInfo, { dailyDeviation: dailyDeviation }))))));
    }));
};
MobileDailyDev.displayName = 'MobileDailyDev';
export default MobileDailyDev;
//# sourceMappingURL=MobileDailyDev.js.map